import { alpha } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ReactNode } from 'react';

type Props = {
  title?: ReactNode;
  id?: string;
};

export const SectionTitle = ({ title, id }: Props) => {
  if (!title) return null;

  return (
    <Box id={id} sx={{ mt: 1 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 700, letterSpacing: '-0.01em' }}>
        {title}
      </Typography>
      <Box
        sx={(theme) => ({
          mt: 0.5,
          height: '2px',
          borderRadius: '2px',
          background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${alpha(
            theme.palette.primary.main,
            0.15,
          )} 40%, transparent 100%)`,
        })}
      />
    </Box>
  );
};

export default SectionTitle;
